import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icon/icon-share.png'
import _imports_1 from '@/assets/icon/icon-right-arrow.png'
import _imports_2 from '@/assets/icon/icon-left-arrow-gray.png'


const _withScopeId = n => (_pushScopeId("data-v-42ae8ac4"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "main"
}
const _hoisted_2 = {
  key: 0,
  class: "mask"
}
const _hoisted_3 = { class: "container" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = {
  key: 1,
  class: "tag-box"
}
const _hoisted_6 = { class: "container" }
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = { class: "btn-box" }
const _hoisted_9 = ["data-bs-toggle", "href"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "share"
}, null, -1))
const _hoisted_11 = { class: "text" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "hover-bg" }, null, -1))
const _hoisted_13 = { class: "share-icon" }
const _hoisted_14 = ["src", "onClick"]
const _hoisted_15 = { class: "text" }
const _hoisted_16 = {
  key: 0,
  src: _imports_1,
  class: "arrow"
}
const _hoisted_17 = { class: "view-count" }
const _hoisted_18 = { class: "footer-wrapper" }
const _hoisted_19 = {
  key: 0,
  class: "author"
}
const _hoisted_20 = { class: "next-story-wrapper" }
const _hoisted_21 = { class: "header" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "title" }, " Next Story ", -1))
const _hoisted_23 = /*#__PURE__*/_createTextVNode(" More > ")
const _hoisted_24 = { class: "row no-gutters" }
const _hoisted_25 = ["id"]
const _hoisted_26 = { class: "offcanvas-body" }
const _hoisted_27 = { class: "share-body" }
const _hoisted_28 = { class: "share-title" }
const _hoisted_29 = { class: "share-icon" }
const _hoisted_30 = ["src", "onClick"]
const _hoisted_31 = {
  key: 0,
  class: "url-copy-btn"
}

import { computed, onMounted, ref } from 'vue';
  import { useRoute, useRouter } from 'vue-router';
  import { useI18n } from 'vue-i18n';
  import { alert, request, facebookShare, isMobile, twitterShare, kakaoShare, lineShare } from '@/utils';
  import { StoryItem } from '@/types/story';
  import ShareFacebookIcon from '@/assets/icon/share/facebook.png';
  import ShareTwitterIcon from '@/assets/icon/share/twitter.png';
  import ShareTalkIcon from '@/assets/icon/share/talk.png';
  import ShareUrlIcon from '@/assets/icon/share/url.png';
  import ShareLineIcon from '@/assets/icon/share/line.svg';
  import { Collection, settingStore } from '@/stores';
  import urlJoin from 'url-join';

  interface Tag {
    type: 'tag' | 'category';
    name: string
    background_color?: string;
    font_color?: string;
  }
  interface ShareIcon {
    icon: string;
    click: () => void;
  }
  
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

  const route = useRoute();
  const router = useRouter();
  const data = ref<StoryItem>();
  const offcanvasId = ref('');
  const { t, locale } = useI18n();
  const mobile = isMobile();
  const storyCollection = Collection.create<Collection>({
    params: {
      type_eq: 'Story',
      per_page: 3,
      id_not_eq: ''
    },
    fetch: (params: object) => request.get('articles', { params })
  });

  const tags = computed<Tag[]>(() => {
    if (!data.value) {
      return [];
    }
    const list: Tag[] = [];
    if (data.value.article_category) {
      list.push({
        type: 'category',
        name: data.value.article_category.title,
        background_color: data.value.article_category.background_color,
        font_color: data.value.article_category.font_color,
      });
    }
    if (Array.isArray(data.value.tag_list)) {
      data.value.tags.forEach((item) => {
        list.push({
          type: 'tag',
          name: item.name,
          background_color: item.background_color,
          font_color: item.font_color,
        });
      });
    }
    return list;
  });
  const copyText = async (text: string) => {
    if (navigator.clipboard && navigator.permissions) {
      await navigator.clipboard.writeText(text);
    } else {
      const textArea: any = document.createElement('textArea');
      textArea.value = text;
      textArea.style.width = '0';
      textArea.style.position = 'fixed';
      textArea.style.left = '-999px';
      textArea.style.top = '10px';
      textArea.setAttribute('readonly', 'readonly');
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand('copy');
      document.body.removeChild(textArea);
    }
  };
  const showCopySuccess = ref(false);
  function hideCopySuccess() {
    showCopySuccess.value = false;
  }
  const shareIcons = computed<ShareIcon[]>(() => {
    return [
      {
        icon: ShareFacebookIcon,
        click: () => {
          hideCopySuccess();
          facebookShare();
        }
      },
      {
        icon: ShareTwitterIcon,
        click: () => {
          hideCopySuccess();
          twitterShare(undefined, data.value?.title || '');
        }
      },
      locale.value === 'ko' && {
        icon: ShareTalkIcon,
        click: () => {
          hideCopySuccess();
          kakaoShare({
            title: data.value?.title || '',
            imageUrl: data.value?.cover?.url || '',
          });
        }
      },
      locale.value === 'ja' && {
        icon: ShareLineIcon,
        click: () => {
          hideCopySuccess();
          lineShare();
        }
      },
      {
        icon: ShareUrlIcon,
        click: async () => {
          const shareUrl = urlJoin(location.origin, router.currentRoute.value.fullPath);
          try {
            copyText(shareUrl);
            if (mobile) {
              showCopySuccess.value = true;
            } else {
              alert({
                content: t('copySuccess'),
                btns: [],
              });
            }
          } catch (e) {
            // TODO: 复制失败
          }
        }
      },
    ].filter(Boolean) as ShareIcon[];
  });

  onMounted(async () => {
    settingStore.tryFetchData();
    const res = await request.get(`articles/${route.params.slug}`);
    data.value = res.data;
    offcanvasId.value = `article-${data.value?.slug}`;
    storyCollection.params.id_not_eq = data.value?.id;
    storyCollection.fetchData();
  });

  function handleClickBtn() {
    if (data.value?.additional_button.button_link) {
      window.open(data.value?.additional_button.button_link, '_blank');
    }
  }

  function getTagStyle(tag: Tag) {
    if (tag.type === 'category') {
      return {
        backgroundColor: tag.background_color || settingStore.data.story_category_background_color,
        color: tag.font_color || settingStore.data.story_category_font_color,
      };
    }
    return {
      backgroundColor: tag.background_color || settingStore.data.story_tag_background_color,
      color: tag.font_color || settingStore.data.story_tag_font_color,
    };
  }

  const backgroundImage = computed(() => {
    if (data.value?.background_image) {
      return data.value?.background_image.url;
    }
    return '';
  });

  const headerStyle = computed(() => {
    const bg = {};
    const title = {};
    if (backgroundImage.value) {
      Object.assign(bg, {
        backgroundImage: `url(${backgroundImage.value})`,
        backgroundSize: 'cover',
      });
    }
    if (data.value?.title_color) {
      Object.assign(title, {
        color: data.value?.title_color,
      });
    }
    return { bg, title };
  });

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_AppCardStory = _resolveComponent("AppCardStory")!

  return (data.value?.id)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", {
          class: "header-wrapper",
          style: _normalizeStyle([_unref(headerStyle).bg])
        }, [
          (_unref(backgroundImage))
            ? (_openBlock(), _createElementBlock("div", _hoisted_2))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_3, [
            (data.value?.title)
              ? (_openBlock(), _createElementBlock("h1", {
                  key: 0,
                  style: _normalizeStyle([{"white-space":"pre-line"}, [_unref(headerStyle).title]]),
                  innerHTML: data.value?.title?.replace(/\\n/g, '<br>') || ''
                }, null, 12, _hoisted_4))
              : _createCommentVNode("", true),
            _createElementVNode("div", {
              class: "summary",
              style: _normalizeStyle([_unref(headerStyle).title])
            }, _toDisplayString(data.value?.summary), 5),
            (data.value?.article_category)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tags), (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: index,
                      class: _normalizeClass(["tag", `lang-${_unref(locale)}`]),
                      style: _normalizeStyle([getTagStyle(item)])
                    }, " #" + _toDisplayString(item.name), 7))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ])
        ], 4),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", {
            class: _normalizeClass(["body-wrapper", `lang-${_unref(locale)}`])
          }, [
            _createElementVNode("div", {
              class: "richText",
              innerHTML: data.value?.content
            }, null, 8, _hoisted_7),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", {
                class: "btn share-btn",
                "data-bs-toggle": _unref(mobile) ? 'offcanvas' : '',
                href: `#${offcanvasId.value}`
              }, [
                _hoisted_10,
                _createElementVNode("span", _hoisted_11, _toDisplayString(_unref(t)('Share')), 1),
                _hoisted_12,
                _createElementVNode("div", _hoisted_13, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(shareIcons), (item, index) => {
                    return (_openBlock(), _createElementBlock("img", {
                      key: index,
                      src: item.icon,
                      class: "icon",
                      onClick: item.click
                    }, null, 8, _hoisted_14))
                  }), 128))
                ])
              ], 8, _hoisted_9),
              (data.value?.additional_button.button_link)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "btn landing",
                    onClick: handleClickBtn
                  }, [
                    _createElementVNode("div", _hoisted_15, _toDisplayString(data.value.additional_button.button_text), 1),
                    (data.value.show_arrow_icon)
                      ? (_openBlock(), _createElementBlock("img", _hoisted_16))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_17, _toDisplayString(_unref(t)('viewsCount', {count: data.value?.views_count})), 1)
          ], 2),
          _createElementVNode("div", _hoisted_18, [
            (data.value?.author)
              ? (_openBlock(), _createElementBlock("div", _hoisted_19, _toDisplayString(_unref(t)('writing')) + " : " + _toDisplayString(data.value.author), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("div", _hoisted_21, [
              _hoisted_22,
              _createVNode(_component_router_link, {
                to: { name: 'story.index' },
                class: "more"
              }, {
                default: _withCtx(() => [
                  _hoisted_23
                ]),
                _: 1
              }, 8, ["to"])
            ]),
            _createElementVNode("div", _hoisted_24, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(storyCollection).data, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: "col-6 col-md-4 item-box"
                }, [
                  _createVNode(_component_AppCardStory, { data: item }, null, 8, ["data"])
                ]))
              }), 128))
            ])
          ])
        ]),
        _createElementVNode("div", {
          id: offcanvasId.value,
          class: "offcanvas offcanvas-end",
          tabindex: "-1"
        }, [
          _createElementVNode("div", { class: "offcanvas-header" }, [
            _createElementVNode("img", {
              src: _imports_2,
              class: "arrow",
              "data-bs-dismiss": "offcanvas",
              "aria-label": "Close",
              onClick: hideCopySuccess
            })
          ]),
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("div", _hoisted_28, _toDisplayString(_unref(t)('shareTitle')), 1),
              _createElementVNode("div", _hoisted_29, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(shareIcons), (item, index) => {
                  return (_openBlock(), _createElementBlock("img", {
                    key: index,
                    src: item.icon,
                    class: "icon",
                    onClick: item.click
                  }, null, 8, _hoisted_30))
                }), 128))
              ]),
              (showCopySuccess.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_31, _toDisplayString(_unref(t)('copySuccess')), 1))
                : _createCommentVNode("", true)
            ])
          ])
        ], 8, _hoisted_25)
      ]))
    : _createCommentVNode("", true)
}
}

})